module.exports = __webpack_public_path__ + "img/中国旅游报_02.71bcc640.jpg";